import React from "react";
import i18n from "~/assets/js/Helpers/i18n";

const DesktopCartFooter = () => {
    return (
        <footer id="footer">
            <div className="footer-links">
                <a href="https://drive.google.com/file/d/1R4Q93NSSI-VcdPaReNtC-y7TjrVEhkBR/view">
                    {i18n.t("footer.allergens")}
                </a>
                <i className="fa fa-circle fa-xs" aria-hidden="true"></i>
                <a href="/presse">{i18n.t("footer.press")}</a>
                <i className="fa fa-circle fa-xs" aria-hidden="true"></i>

                <a href="/jobs">{i18n.t("footer.jobs")}</a>
                <i className="fa fa-circle fa-xs" aria-hidden="true"></i>

                <a href="/datenshutz">{i18n.t("footer.dataProtection")}</a>
                <i className="fa fa-circle fa-xs" aria-hidden="true"></i>

                <a href="/agb">{i18n.t("footer.terms")}</a>
                <i className="fa fa-circle fa-xs" aria-hidden="true"></i>

                <a href="/widerrufsbelehrung">{i18n.t("footer.withdrawal")}</a>
                <i className="fa fa-circle fa-xs" aria-hidden="true"></i>

                <a href="/cookie-erklaerung/">{i18n.t("footer.cookies")}</a>
                <i className="fa fa-circle fa-xs" aria-hidden="true"></i>

                <a href="https://pottsalat.de/Vermoegensanlagen-Informationsblatt-Pottsalat-GmbH.pdf">
                    {i18n.t("footer.investors")}
                </a>
            </div>
        </footer>
    );
};

export default DesktopCartFooter;
